module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box american-credit-partner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_c('h1', [_vm._v("Want to partner with American Credit®? Let's join forces.")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/partner'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform contact-us"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 contact-us-left"
  }, [_c('h4', {
    staticClass: "contact-us-title"
  }, [_vm._v("Drop us a line")]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-text"
  }, [_vm._v("Whether you want to start a partnership or become a broker, we are happy to work with you. Please feel free to send us a message.")]), _vm._v(" "), _c('el-form', {
    ref: "step2Form",
    staticClass: "row",
    attrs: {
      "label-width": '0',
      "model": _vm.step2Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "firstName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First Name*"
    },
    model: {
      value: (_vm.step2Form.firstName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "firstName", $$v)
      },
      expression: "step2Form.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "lastName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last Name*"
    },
    model: {
      value: (_vm.step2Form.lastName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "lastName", $$v)
      },
      expression: "step2Form.lastName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "email",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email*"
    },
    model: {
      value: (_vm.step2Form.email),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "email", $$v)
      },
      expression: "step2Form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-6",
    attrs: {
      "prop": "phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone*"
    },
    model: {
      value: (_vm.step2Form.phone),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "phone", $$v)
      },
      expression: "step2Form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "col-12",
    attrs: {
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Message content."
    },
    model: {
      value: (_vm.step2Form.content),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "content", $$v)
      },
      expression: "step2Form.content"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-button', {
    staticClass: "rounded-pill font-weight-bold",
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "54px",
      "width": "190px",
      "border-radius": "27px",
      "border": "none",
      "margin-top": "36px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Send Message")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("American Credit: The difference you can trust")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _vm._m(8)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Partner with American Credit. Help your clients get the financing they need. Deliver an incredible customer experience. Generate incremental revenue. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/partner"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "american-credit-partner-main-img",
    attrs: {
      "src": require("../assets/imgs/american_credit_business_loan_partner.png"),
      "alt": "american credit business loan partner"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback partner-with-leaders"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/partner_with_leaders.png"),
      "alt": "american credit partner with leaders"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('h2', {
    staticClass: "partner-with-leaders-title"
  }, [_vm._v("Partnered with leaders from many industries")]), _vm._v(" "), _c('p', {
    staticClass: "partner-with-leaders-text"
  }, [_vm._v("To ensure our customers get the secured business loans they need quickly and affordably, American Credit partners with leaders from a diverse range of industries. By combining their skills and technologies with our financial data and risk management expertise we can offer customers a wide scope of asset backed loans, invoice factoring loans, and other cash flow loans on a fair, responsible and affordable basis.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center partners-title"
  }, [_vm._v("Our key finance, technology and security partners include:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row partner-items"
  }, [_c('div', {
    staticClass: "col-6 col-lg-2 partner-item-wrapper"
  }, [_c('div', {
    staticClass: "partner-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/logo-experian.svg"),
      "alt": "american credit partner experian"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2 partner-item-wrapper"
  }, [_c('div', {
    staticClass: "partner-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/plaid_logo.svg"),
      "alt": "american credit partner plaid"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2 partner-item-wrapper"
  }, [_c('div', {
    staticClass: "partner-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/ocrolus_logo.png"),
      "alt": "american credit partner ocrolus"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2 partner-item-wrapper"
  }, [_c('div', {
    staticClass: "partner-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/aws-logo.png"),
      "alt": "american credit partner aws"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2 partner-item-wrapper"
  }, [_c('div', {
    staticClass: "partner-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/twilio-logo-red.png"),
      "alt": "american credit partner twilio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2 partner-item-wrapper"
  }, [_c('div', {
    staticClass: "partner-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/logo_hubspot.png"),
      "alt": "american credit partner hubspot"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 offset-lg-1",
    staticStyle: {
      "border-bottom": "1px solid #dfdfdf"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform referral-program"
  }, [_c('div', {
    staticClass: "row referral-program-inner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 referral-program-inner-left"
  }, [_c('h2', [_vm._v("Referral program")]), _vm._v(" "), _c('p', [_vm._v("Introduce American Credit to your clients and benefit from our generous referral program."), _c('br'), _vm._v("Grow your business, get perks, and help your customers. We are always looking for new partners to bring financial power to small businesses.")]), _vm._v(" "), _c('div', {
    staticClass: "referral-program-inner-left-why"
  }, [_c('h4', [_vm._v("Why become a referral partner?")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("We empower ISOs, brokers, and affiliates to effectively serve clients from start to finish")]), _vm._v(" "), _c('li', [_vm._v("We offer a flexible, revolving credit solution that clients want at competitive rates")]), _vm._v(" "), _c('li', [_vm._v("We achieve an 80%+ approval rate on qualified leads in general")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 referral-program-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Referral_Program.png"),
      "alt": "American Credit Business Loans Referral Program"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 contact-us-right"
  }, [_c('h4', {
    staticClass: "contact-us-title"
  }, [_vm._v("Get in touch with us")]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-text"
  }, [_vm._v("We understand. Sometimes you just want to get a few answers and move on with business.")]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_location.png"),
      "alt": "american credit location"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Address")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("2100 Geng Road, Suite 210"), _c('br'), _vm._v(" Palo Alto, CA 94303")])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_phone.png"),
      "alt": "american credit phone"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Phone")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:1855-904-0188"
    }
  }, [_vm._v("855-904-0188")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact-card"
  }, [_c('div', {
    staticClass: "col-1 contact-card-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/american_credit_email.png"),
      "alt": "american credit email"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 contact-card-text"
  }, [_c('h5', [_vm._v("Email")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:info@amcredit.com"
    }
  }, [_vm._v("info@amcredit.com")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text",
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("You work hard. We work hard. We share the same ethic.")]), _vm._v(" That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "contact-us"
    }
  }, [_vm._v("Feel free to contact us "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png"),
      "alt": "American Credit Business loans the Difference You can Trust"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5720d39a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partners.vue
// module id = 1983
// module chunks = 5